import React from 'react'
import styled, { css } from 'styled-components'
import { Flex, ButtonUnstyled } from '@sketch/components'
import { ReactComponent as Cross } from '@sketch/icons/cross-circle-semifilled-17'

const PanelTitle = styled.span(
  ({ theme }) => css`
    color: rgba(0, 0, 0, 0.85);
    font-family: ${theme.colors.foreground.secondary.B};
    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.semibold};
  `
)

const iconStyles = css`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const CloseIcon = styled(Cross)`
  ${iconStyles}
`

export const CloseButton = styled(ButtonUnstyled)`
  ${iconStyles}
  margin-left: 16px;
`

interface PopoverHeaderProps {
  onClose?: () => void
  title: string | React.ReactNode
  extraAction?: React.ReactNode
}

export const PopoverHeader = ({
  onClose,
  title,
  extraAction,
}: PopoverHeaderProps) => {
  return (
    <Flex
      pt={4}
      pl={5}
      pr={5}
      justifyContent="space-between"
      alignItems="center"
    >
      <PanelTitle>{title}</PanelTitle>
      <Flex alignItems="center" flexDirection="row">
        {extraAction}
        {onClose ? (
          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        ) : null}
      </Flex>
    </Flex>
  )
}
